module.exports = __webpack_public_path__ + "img/AsiaZInsta_final.2b2fb8d1.jpg";